// 引入公共 store 配置（来自 channel_app.js）
// store 和 Vuex 变量已通过 CDN 在 public/index.html 中全局定义

// 添加car台到兄弟台列表
if (store && store.state && store.state.taiwan) {
    store.state.taiwan.push({
        url: 'car',
        name: '车行天下台'
    });
}

// 扩展 mutations，覆盖 changeKeys 和 getTaiwan 以适配本项目
const customMutations = {
    changeKeys(state, keys) {
        state.keys = keys
        state.size = 17
        state.text = []
    },
    getTaiwan(state, url) {
        if (url === 'car') {
            state.allNav = [
                {
                    name: '资讯',
                    english: 'Information',
                    child: [
                        { name: '首页', url: 'broadcast' },
                        { name: '报告', url: 'reportCar' },
                        { name: '融资', url: 'financeCar' },
                        { name: '专题', url: 'project' },
                        { name: '短视频', url: 'shortvideo' },
                    ]
                },
                {
                    name: '研究',
                    english: 'Research',
                    child: [
                        { name: '报告发布', url: 'report' },
                        { name: '热点快评', url: 'evaluation' },
                        { name: '数据榜单', url: 'list' },
                    ]
                },
                {
                    name: '服务',
                    english: 'Service',
                    child: [
                        { name: '我要合作', url: '/Index/Wjsproviders.html' },
                        { name: '我要融资', url: '/Index/finance.html' },
                        { name: '我要数据', url: '/Index/dsb_product.html' },
                        { name: '我要投诉', url: '/Index/complain.html' },
                    ]
                },
                {
                    icon: 'el-icon-s-comment',
                    name: '投诉',
                    url: 'complainList',
                    child: [
                        { name: '我要投诉', url: '/Index/complain.html' },
                        { name: '投诉榜', url: 'complainList' },
                        { name: '曝光台', url: 'complainList' },
                    ]
                },
            ];
        } else {
            for (var i of state.allNav) {
                for (var j = 0; j < i.child.length; j++) {
                    if (i.child[j].contains != undefined && i.child[j].contains.indexOf(url) == -1) {
                        i.child.splice(j--, 1)
                    }
                }
            }

            state.allNav.forEach(item => {
                if (item.url != undefined) {
                    state.buttons.push(item)
                } else if (item.contains == undefined || item.contains.indexOf(url) != -1) {
                    state.dropList.push(item)
                }
            })
            state.buttons.splice(2, 0, {})

            for (var i = 0; i < state.allNav.length; i++) {
                if (state.allNav[i].child.length == 0 || state.allNav[i].contains != undefined) {
                    state.allNav.splice(i--, 1)
                }
            }
        }

        for (var i in state.taiwan) {
            if (state.taiwan[i].url == url) {
                state.taiwan.splice(i, 1)
            }
        }
    }
}

// 合并自定义 mutations 到全局 store
if (store && store.mutations) {
    Object.assign(store.mutations, customMutations)
}

export default new Vuex.Store(store)